<ul class="tab-panel rs" *ngIf="tabs">
    <li class="tab" *ngFor="let tab of tabs" (click)="selectTab(tab)" [class.active]="tab.active" [ngClass]="extraClass">
        {{tab.title}}
    </li>
</ul>

<ul class="tab-panel fs" *ngIf="activeEntry && inactiveEntries">
    <li class="tab active" [ngClass]="extraClass">
        <span>{{activeEntry.title}}</span>
        <span class="icon icon-open"></span>
    </li>
    <li>
        <ul class="tab-inactive">
            <li class="tab" *ngFor="let tab of inactiveEntries" [ngClass]="extraClass" (click)="selectTab(tab)">{{tab.title}}</li>
        </ul>
    </li>
</ul>
